module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("l3tmi"))).then(() => parcelRequire('hEqeo'));